// This module exists both to handle browsers that doesn't have `sessionStorage`
// and for private browsing in iOS which throws exceptions when you call `setItem`

const fauxStorage: { [key: string]: any } = {};

export function setSesstionStorage(key: string, value: any) {
  try {
    if (!__BROWSER__) {
      console.warn('setSessionStorage should not be called during server-side rendering');
      return;
    }

    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    fauxStorage[key] = value;
    console.error('sessionStorage.setItem() failed:', e);
  }
}

export function getSessionStorage<T>(key: string, defaultValue?: T) {
  if (!__BROWSER__) {
    console.warn('getSessionStorage should not be called during server-side rendering');
    return defaultValue;
  }

  try {
    const value = sessionStorage.getItem(key);
    if (value === null) {
      return defaultValue;
    } else {
      return JSON.parse(value) as T;
    }
  } catch (e) {
    console.error('sessionStorage.getItem() failed:', e);
    if (!(key in fauxStorage)) {
      return defaultValue;
    }
    return fauxStorage[key] as T;
  }
}
